<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Edit Item</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    class="dialog-close-button"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #form="ngForm">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Name</mat-label>
      <input matInput placeholder="Name" [value]="pivot.item?.name" type="text" disabled />
    </mat-form-field>

    <div class="mb-4">
      <p>{{ pivot.item?.question }}</p>
      <mat-button-toggle-group [(ngModel)]="pivot.answer" name="answer" aria-label="Answer">
        <mat-button-toggle value="Yes">Yes</mat-button-toggle>
        <mat-button-toggle value="No">No</mat-button-toggle>
        <mat-button-toggle value="NA">Not Applicable</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Notes</mat-label>
      <textarea matInput placeholder="Notes" [(ngModel)]="pivot.notes" name="notes" type="text" rows="5"></textarea>
    </mat-form-field>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <p>Rating</p>
          <app-rating [rating]="pivot.rating" [edit]="true" (ratingChanged)="pivot.rating = $event"></app-rating>
        </div>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Expiry Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="Expiry Date"
            readonly
            (click)="picker.open()"
            [(ngModel)]="expiry"
            name="date"
            id="date"
            [min]="now" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>

          <button
            type="button"
            matSuffix
            mat-icon-button
            *ngIf="expiry"
            (click)="onRemoveExpiryDate($event)"
            matTooltip="Remove the Pre-Qualification Item Expiry Date.">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <div class="full-width mb-4" *ngIf="expiryDateChanged()">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Reason for Expiry Date Change</mat-label>
        <textarea
          matInput
          [(ngModel)]="expiryChangeNote"
          name="expiryChangeNote"
          placeholder="Required if no file is attached">
      </textarea>
        <mat-hint>
          This note will be included in the notification email. You can also attach a file instead.
        </mat-hint>
      </mat-form-field>
    </div>

    <ng-container *ngIf="pivot.files?.length">
      <p>Uploaded Files</p>

      <mat-list>
        <mat-list-item class="mat-list-item-overflow-fix" *ngFor="let file of pivot.files; let i = index; let isLast = last;">
          <img matListItemAvatar class="rounded-0" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [src]="file.url" [alt]="file.name" *ngIf="utils.isImage(file.name)" />
          <img matListItemAvatar class="rounded-0" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [alt]="file.name" src="./assets/images/document-placeholder.png" *ngIf="!utils.isImage(file.name)" />
          <div matListItemTitle class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [matTooltip]="file.name"> {{ file.name | truncateFileName:30 }} </div>
          <div matListItemLine class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"> Created: {{ (file.date_created * 1000) | timezoneConvertMedium }} </div>
          <div matListItemLine class="text-wrap" style="cursor: pointer;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"> Last Modified: {{ (file.date_modified * 1000) | timezoneConvertMedium }} </div>

          <button
            matListItemMeta
            mat-icon-button
            ngxClipboard
            aria-label="Copy file URL"
            matTooltip="Copy this file URL."
            [cbContent]="file.url"
            (click)="onCopiedURL()"
            class="dialog-button my-auto ml-2 mr-0"
            style="cursor: pointer;">
            <mat-icon>content_copy</mat-icon>
          </button>

          <button
            matListItemMeta
            mat-icon-button
            aria-label="Download file"
            matTooltip="Download this file."
            (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"
            class="dialog-button my-auto ml-2 mr-0"
            style="cursor: pointer;">
            <mat-icon>download</mat-icon>
          </button>

          <button
            matListItemMeta
            mat-icon-button
            aria-label="Preview file"
            matTooltip="View this file."
            (click)="onOpenUrl(file.url)"
            class="dialog-button my-auto ml-2 mr-0"
            style="cursor: pointer;">
            <mat-icon>preview</mat-icon>
          </button>

          <button
            matListItemMeta
            mat-icon-button
            color="warn"
            aria-label="Delete file"
            matTooltip="Delete this file."
            (click)="onDeleteSelectedFiles(file.id, i, $event)"
            class="dialog-remove-button my-auto ml-2 mr-0">
            <mat-icon>delete</mat-icon>
          </button>

          <mat-divider class="w-100 m-0" [inset]="true" *ngIf="!isLast"></mat-divider>
        </mat-list-item>
      </mat-list>
    </ng-container>

  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    mat-raised-button
    color="primary"
    id="save"
    type="submit"
    class="my-2 ml-1 mr-2"
    (click)="onSave()"
    [disabled]="inProgress">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <app-file-browse-button
    (selectedFiles)="onSelectedFiles($event)"
    (afterDialogClosedEvent)="onSave()"
    [getSelectedFiles]=true
    [parentObjectType]="'contractor-pre-qualification-item-pivot'"
    [parentObjectId]="pivot?.id"
    [filesCount]="pivot?.files?.length">
  </app-file-browse-button>
</mat-dialog-actions>
